export enum DeliveryType {
    FirstPartyAdvertiser = 0,
    FirstDataProvider = 1,
    ThirdPartySyndicated = 2,
    ThirdPartyCustom = 3,
}
